// En el dominio principal la app vive en /beyond, así que el backend está en /beyond/backend.
const PRODUCTION_API_PATH = '/beyond/backend';
// En beyondlimitsglobal.org la app y el API viven en la raíz del dominio.
const BEYOND_LIMITS_API_PATH = '/backend';
const BEYOND_LIMITS_API_URL = 'https://beyondlimitsglobal.org/backend';

const isLocalDevHost = (hostname) =>
  hostname === 'localhost' || hostname === '127.0.0.1';

const isMainProductionHost = (hostname) =>
  hostname === 'institutobilinguelasnaciones.com' ||
  hostname === 'www.institutobilinguelasnaciones.com';

const isBeyondSubdomainHost = (hostname) =>
  Boolean(
    hostname &&
      hostname !== 'www.institutobilinguelasnaciones.com' &&
      hostname.endsWith('.institutobilinguelasnaciones.com')
  );

const isBeyondLimitsHost = (hostname) =>
  hostname === 'beyondlimitsglobal.org' || hostname === 'www.beyondlimitsglobal.org';

const isProductionHost = (hostname) =>
  isMainProductionHost(hostname) ||
  isBeyondSubdomainHost(hostname) ||
  isBeyondLimitsHost(hostname);

// En desarrollo usamos proxy de CRA (package.json) para evitar CORS con localhost.
// Para probar directo contra producción: REACT_APP_USE_DIRECT_API=true npm start
export const API_BASE_URL = (() => {
  if (typeof window !== 'undefined') {
    const { hostname, protocol } = window.location;

    if (
      process.env.NODE_ENV === 'development' &&
      isLocalDevHost(hostname) &&
      process.env.REACT_APP_USE_DIRECT_API !== 'true'
    ) {
      return '';
    }

    if (isBeyondLimitsHost(hostname)) {
      return `${protocol}//${hostname}${BEYOND_LIMITS_API_PATH}`;
    }

    if (isBeyondSubdomainHost(hostname)) {
      // Subdominio antiguo: API ya migrada a beyondlimitsglobal.org
      return process.env.REACT_APP_API_URL || BEYOND_LIMITS_API_URL;
    }

    if (isMainProductionHost(hostname)) {
      return `${protocol}//${hostname}${PRODUCTION_API_PATH}`;
    }

    if (isProductionHost(hostname)) {
      return `${protocol}//${hostname}${PRODUCTION_API_PATH}`;
    }
  }

  if (
    process.env.NODE_ENV === 'development' &&
    process.env.REACT_APP_USE_DIRECT_API !== 'true'
  ) {
    return '';
  }

  return process.env.REACT_APP_API_URL || BEYOND_LIMITS_API_URL;
})();

export const isApiEnabled = () => Boolean(API_BASE_URL || process.env.NODE_ENV === 'development');

export const apiPublicUrl = (path) => {
  const suffix = String(path || '').replace(/^\//, '');
  const base = (API_BASE_URL || process.env.REACT_APP_API_URL || BEYOND_LIMITS_API_URL).replace(/\/$/, '');

  return suffix ? `${base}/${suffix}` : base;
};
